import React from "react";
import PaginationTable from "../../components/paginationTable/PaginationTable";
import { textFilter } from "react-bootstrap-table2-filter";
import CamplaCoreService from "../../services/CamplaCoreService";
import Button from "react-bootstrap/Button";
import UnsavedChangesDialog from "../../components/dialogs/unsavedChangesDialog/UnsavedChangesDialog";
import ModulesActionCell from "./moduleActionCell/ModulesActionCell";
import StorageService from "../../services/StorageService";

import {
  ButtonGroup,
  Col,
  Container,
  Row,
  ToggleButton,
} from "react-bootstrap";
import { withTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilter, faPlus } from "@fortawesome/free-solid-svg-icons";
import APIErrorHelper from "../../helpers/APIErrorHelper";
import DeleteDialog from "../../components/dialogs/deleteDialog/DeleteDialog";
import ModuleDialog from "./dialogs/moduleDialog/ModuleDialog";
import DescriptionDialog from "./dialogs/descriptionDialog/descriptionDialog";

class Modules extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modules: [],
      departments: [],
      showModuleDialog: false,
      showDeleteDialog: false,
      showUnsavedChangesDialog: false,
      showDescriptionDialog: false,
      closeAction: () => {},
      moduleToDeleteOrEdit: null,
      errorMessage: "",
      displayFilter: "none",
      showFilters: false,
      dialogApiError: "",
      apiError: "",
    };
    this.loadData = this.loadData.bind(this);
    this.loadCachedData = this.loadCachedData.bind(this);
    this.handleCreateModule = this.handleCreateModule.bind(this);
    this.handleUpdateModule = this.handleUpdateModule.bind(this);
    this.handleDeleteModule = this.handleDeleteModule.bind(this);
  }

  async componentDidMount() {
    this.paginationTableRef = React.createRef();
    this.loadCachedData();
    this.setState(await this.loadData());
  }

  async handleCreateModule(moduleToCreate) {
    try {
      let createdModule = await CamplaCoreService.createModule(moduleToCreate);
      const me = StorageService.getUser();
      createdModule["user"] = {
        email: me.email,
        name: me.displayName,
      };
      this.state.modules.push(createdModule);
      const updatedModules = [...this.state.modules];
      StorageService.set("modules", updatedModules);
      this.setState({
        showModuleDialog: false,
        modules: updatedModules,
      });
    } catch (err) {
      this.setState({
        dialogApiError: APIErrorHelper.getError(
          err,
          () => this.setState({ dialogApiError: "" }),
          {
            PRECONDITION_FAILED: "Modules.APIError.PreconditionFailed",
            CONFLICT: "Modules.APIError.CreateConflict",
          },
          this.props.t
        ),
      });
    }
  }

  async handleUpdateModule(changedClass) {
    try {
      let updatedModule = await CamplaCoreService.updateModule(
        this.state.moduleToDeleteOrEdit._id,
        changedClass
      );
      const me = StorageService.getUser();
      updatedModule["user"] = {
        email: me.email,
        name: me.displayName,
      };
      for (const i in this.state.modules) {
        if (this.state.modules[i]._id === updatedModule._id) {
          this.state.modules[i] = Object.assign({}, updatedModule);
          break;
        }
      }
      const updatedModules = [...this.state.modules];
      StorageService.set("modules", updatedModules);
      this.setState({
        showModuleDialog: false,
        modules: updatedModules,
        moduleToDeleteOrEdit: null,
      });
    } catch (err) {
      this.setState({
        dialogApiError: APIErrorHelper.getError(
          err,
          () => this.setState({ dialogApiError: "" }),
          {
            PRECONDITION_FAILED: "Modules.APIError.PreconditionFailed",
            NOT_FOUND: "Modules.APIError.NotFound",
            CONFLICT: "Modules.APIError.UpdateConflict",
          },
          this.props.t
        ),
      });
    }
  }

  async handleDeleteModule() {
    try {
      await CamplaCoreService.deleteModule(this.state.moduleToDeleteOrEdit._id);
      const updatedModules = this.state.modules.filter(
        (x) => x._id !== this.state.moduleToDeleteOrEdit._id
      );
      this.setState({
        showDeleteDialog: false,
        modules: updatedModules,
        moduleToDeleteOrEdit: null,
      });
    } catch (err) {
      this.setState({
        dialogApiError: APIErrorHelper.getError(
          err,
          () => this.setState({ dialogApiError: "" }),
          {
            PRECONDITION_FAILED: "Modules.APIError.PreconditionFailed",
            NOT_FOUND: "Modules.APIError.NotFound",
            CONFLICT: "Modules.APIError.DeleteConflict",
          },
          this.props.t
        ),
      });
    }
  }

  loadCachedData() {
    this.setState({
      modules: StorageService.getReferenceType("modules") || [],
      departments: StorageService.getReferenceType("departments") || [],
    });
  }

  async loadData() {
    try {
      const modules = await CamplaCoreService.getAllModules();
      const departments = await CamplaCoreService.getAllModuleDepartments();
      StorageService.set("modules", modules);
      StorageService.set("departments", departments);

      return {
        modules,
        departments,
      };
    } catch (err) {
      this.setState({
        apiError: APIErrorHelper.getError(
          err,
          () => this.setState({ apiError: "" }),
          {},
          this.props.t
        ),
      });
    }
    return {
      modules: [],
      departments: [],
    };
  }

  render() {
    const { t } = this.props;
    const columns = [
      {
        dataField: "abbreviation",
        text: t("Modules.ColumnAbbreviation"),
        sort: true,
        filter: textFilter({
          style: { display: this.state.displayFilter },
          // placeholder: ' '
        }),
      },
      {
        dataField: "name",
        text: t("Modules.ColumnName"),
        sort: true,
        filter: textFilter({
          style: { display: this.state.displayFilter },
          // placeholder: ' '
        }),
      },
      {
        dataField: "actions",
        text: "",
        headerFormatter: () => (
          <ButtonGroup toggle style={{ float: "right", marginRight: "-12px" }}>
            <ToggleButton
              type="checkbox"
              value={1}
              className={"btn-green btn-sm"}
              checked={this.state.showFilters}
              onChange={(e) => {
                this.setState({
                  showFilters: e.currentTarget.checked,
                  displayFilter: e.currentTarget.checked ? "initial" : "none",
                });
              }}
            >
              <FontAwesomeIcon icon={faFilter} />
            </ToggleButton>
          </ButtonGroup>
        ),
        headerClasses: "actionHeader",
        isDummyField: true,
        csvExport: false,
        formatter: (cell, module) => {
          return (
            <ModulesActionCell
              onEdit={() =>
                this.setState({
                  showModuleDialog: true,
                  moduleToDeleteOrEdit: module,
                  submitFunction: this.handleUpdateModule,
                  dialogTitle: t("Modules.UpdateDialog.Title"),
                  dialogSubmitText: t("Modules.UpdateDialog.Submit"),
                })
              }
              onDelete={() =>
                this.setState({
                  showDeleteDialog: true,
                  moduleToDeleteOrEdit: Object.assign({}, module),
                })
              }
              showDescription={() =>
                this.setState({
                  showDescriptionDialog: true,
                  moduleToDeleteOrEdit: module,
                })
              }
              module={module}
            />
          );
        },
      },
    ];

    return (
      <div>
        <ModuleDialog
          title={this.state.dialogTitle}
          submitText={this.state.dialogSubmitText}
          show={this.state.showModuleDialog}
          module={this.state.moduleToDeleteOrEdit}
          onHide={(isFormDirty) => {
            if (isFormDirty) {
              this.setState({
                dialogApiError: null,
                showUnsavedChangesDialog: true,
                closeAction: () =>
                  this.setState({
                    showModuleDialog: false,
                  }),
              });
            } else {
              this.setState({
                dialogApiError: null,
                showModuleDialog: false,
              });
            }
          }}
          onSubmit={this.state.submitFunction}
          dialogApiError={this.state.dialogApiError}
          departments={this.state.departments}
        />

        <DeleteDialog
          show={this.state.showDeleteDialog}
          onHide={() => this.setState({ showDeleteDialog: false })}
          onSubmit={this.handleDeleteModule}
          dialogApiError={this.state.dialogApiError}
          title={t("Modules.DeleteModal.Title")}
          body={t("Modules.DeleteModal.Text", {
            moduleName: this.state.moduleToDeleteOrEdit?.name,
          })}
          rightButtonText={t("Modules.DeleteModal.Confirm")}
          leftButtonText={t("DialogCancel")}
        />
        <UnsavedChangesDialog
          show={this.state.showUnsavedChangesDialog}
          onHide={() => this.setState({ showUnsavedChangesDialog: false })}
          onSubmit={() => {
            this.setState({ showUnsavedChangesDialog: false });
            this.state.closeAction();
          }}
        />

        <DescriptionDialog
          show={this.state.showDescriptionDialog}
          description={this.state.moduleToDeleteOrEdit?.description}
          lang={this.props.i18n.language}
          onHide={() => this.setState({ showDescriptionDialog: false })}
          dialogApiError={this.state.dialogApiError}
        />

        <Container className="mt-3">
          <Row className="pageTitle">
            <Col>
              <h2>{t("Modules.Title")}</h2>
            </Col>
            <Col>
              <Button
                className={"btn-green"}
                style={{ float: "right" }}
                onClick={() =>
                  this.setState({
                    showModuleDialog: true,
                    submitFunction: this.handleCreateModule,
                    dialogTitle: t("Modules.CreateDialog.Title"),
                    dialogSubmitText: t("Modules.CreateDialog.Submit"),
                    moduleToDeleteOrEdit: null,
                  })
                }
              >
                <FontAwesomeIcon icon={faPlus} />
              </Button>
            </Col>
          </Row>
          {this.state.apiError ? (
            <Row>
              <Col>{this.state.apiError}</Col>
            </Row>
          ) : (
            ""
          )}
          <Row>
            <Col>
              <PaginationTable
                data={this.state.modules}
                sizePerPage={10}
                paginationSize={3}
                columns={columns}
                keyField={"_id"}
                ref={this.paginationTableRef}
                view="modules"
              />
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default withTranslation()(Modules);
